import 'handsontable';
import HandsontableFunctions from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableFunctions.js';
import HandsontableControls from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableControls.js';
import HandsontableRenderers from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableRenderers.js';
import HandsontableValidators from '../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableValidators.js';

import bootstrapNotify from '../../../../../modules/Gull/Framework/bootstrapNotify.js';

const uitvraag = {
	init: function () {
		var stap = document.querySelector('div.step-tabs ul.nav.nav-tabs').getAttribute('data-tab-active');
		document.querySelector('.nav-tabs-active-' + stap + ' .nav-link').classList.add('active');

		if (typeof window.app.router !== 'undefined' && (window.app.router.routerType || 'build') === 'dev') {
			setTimeout(async () => {
				uitvraag.initGrid();
			}, 200);
		} else {
			setTimeout(async () => {
				const vendor = await import('../../../../../modules/VerzekeringsInzicht/App/handsontable/handsontableLoader.js');
				uitvraag.initGrid();
			}, 200);
		}
	},

	initGrid() {
		// Check of er een handsontable element is in DOM
		if ($('#handsontable').length) {
			HandsontableControls.init();
			HandsontableRenderers.init();
			HandsontableValidators.init();

			// Define Handsontable Element and get settings from DOM
			var hotEl = document.getElementById('handsontable');
			var gridSettings = JSON.parse(hotEl.getAttribute('data-settings'));
			var gridData = JSON.parse(hotEl.getAttribute('data-data'));
			var gridDescription = hotEl.getAttribute('data-description');
			var gridStap = hotEl.getAttribute('data-stap');
			var uitvraagID = $('.form-uitvraag').data('uitvraag-id');
			var allowEmpty = hotEl.getAttribute('data-allow-empty') || false;

			// Init Handsontable instance
			window.app.hot = new Handsontable(hotEl, {
				colHeaders: gridSettings[gridDescription]['headers'],
				columns: gridSettings[gridDescription]['columns'],
				colWidths: gridSettings[gridDescription]['colWidths'],
				contextMenu: ['row_above', 'row_below', 'remove_row', 'copy', 'cut', 'paste'],
				data: gridData,
				licenseKey: 'non-commercial-and-evaluation',
				rowHeights: 30,
				stretchH: 'all',
				outsideClickDeselects: false,
				afterChange: function (changes, source) {
					setTimeout(function () {
						// Geef velden in DOM de JSON en de CSV als waarde
						document.getElementsByName('dataJSON')[0].value = JSON.stringify(window.app.hot.getData());
						HandsontableFunctions.saveData(window.app.hot, gridStap, window.app.ajaxPath);
						var columns = {};
						columns.settings = gridSettings[gridDescription]['columns'];
						HandsontableFunctions.formatAfterChange(changes, source, columns, window.app.hot);
						window.app.hot.validateCells();
					}, 0);
				},
				afterGetColHeader: function (col, th) {
					HandsontableFunctions.createHeaderTooltip(col, th, gridSettings[gridDescription]);
				},
				afterInit: function () {
					HandsontableFunctions.removePreloader();
					setTimeout(function () {
						window.app.hot.validateCells();
						$('form[data-validate] button[type=button]').removeAttr('disabled');
					}, 0);
				},
			});

			// Submit function that check if there are no validation errors before submitting
			$('form[data-validate] button[type=submit].btn-submit').attr('type', 'button');
			$('form[data-validate] button[type=button].btn-submit').on('click', function () {
				window.app.hot.validateCells();

				// Definieer of het grid leeg mag zijn
				var hasRows;
				if (allowEmpty) {
					hasRows = true;
				} else {
					hasRows = HandsontableFunctions.hasRows(window.app.hot);
				}
				// Valideer het grid, check of het grid leeg is terwijl het niet leeg mag zijn en open bevestigsmodaal of toon foutmelding
				if (HandsontableFunctions.isValid(window.app.hot) && hasRows == true) {
					HandsontableFunctions.saveData(window.app.hot, gridStap, window.app.ajaxPath);
					$('#modalBevestigen').modal('show', {
						keyboard: false,
						backdrop: 'static',
					});
				} else {
					bootstrapNotify('danger', '', 'Er zijn fouten gevonden in het grid. Zorg dat er tenminste één regel toegevoegd en corrigeer roodgekleurde cellen.', 5000);
				}
				return false;
			});
		} else {
			$('form[data-validate] button[type=submit].btn-submit').removeAttr('disabled');
		}

		// Bind functie die de ingevoerde gegevens in het formulier submit aan button in modal
		$('#modalBevestigen').on('click', '.btn-submit-confirm', function () {
			uitvraag.submitForm();
		});
	},

	// Functie die de ingevoerde gegevens in het formulier submit
	submitForm: function () {
		$('#modalBevestigen').modal('hide');
		setTimeout(function () {
			$('form[data-validate]')[0].submit();
		}, 200);
	},
};

export default uitvraag;
